export default "__VITE_ASSET__CPI5NBcK__"